import { Info } from "lucide-react";
import { useLang } from "@/i18n";

export const NoticeBar = () => {
  const { t, lang } = useLang();
  const size = lang === "pl" ? "text-[14px] sm:text-[15px] font-medium text-[#1A2522]" : "text-[12.5px]";
  return (
    <div data-testid="notice-bar" role="note" className="border-b border-[#D3CEC4]/60 bg-[#EAE5D9]/50">
      <div className="max-w-7xl mx-auto px-6 sm:px-12 py-3 flex items-start gap-3 text-[#495854]">
        <Info className="w-4 h-4 mt-1 shrink-0 text-[#7A4D41]" aria-hidden="true" />
        <p data-testid="notice-bar-text" className={`${size} leading-relaxed`}>
          <span className="tracking-[0.22em] uppercase font-semibold text-[#7A4D41] mr-2">{t.notice.label}</span>
          {t.notice.text}
        </p>
      </div>
    </div>
  );
};
